<template>
    <div class="vx-card p-6 minus-top">
      <div class="warning">
        <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <div class="vx-row" style="margin-left:0px">
            <feather-icon icon="SettingsIcon" style="margin-right :10px"> </feather-icon>
            <span><h3 class="text-title">{{$t('warningManager.setUp')}}</h3></span>
          </div>
        </div>
      </div>
      </div>

      <div class="warning" style="margin-bottom:50px; margin-top:40px">
        <div class="vx-row">
          <div class="vx-col w-full mt-2" style=" margin-bottom:10px;">
              <label ><h3 class="text-title">{{$t('warningManager.listWarning')}}</h3></label>
              <div style="float:right">
                <vs-button icon="icon-plus" icon-pack="feather" type ="border" @click="addWarning">{{$t('button.newWarning')}}</vs-button>
              </div>
          </div>
      </div>

      <div class="rows">
        <div class="vx-row">
        <div class="vx-col w-full mt-2">
              <div class="vx-row" style="">
                <div class="vx-col md:w-1/2 w-full mt-2" style="max-width:48%;min-width:40%">
                  <span class="text-topic">{{$t('warningManager.warning')}}</span>
              </div>

              <div class="vx-col md:w-4/6 w-full mt-2" style="max-width:30%">
                  <span class="text-topic" style="margin-left:5px;text-align:center">{{$t('warningManager.frequency')}}</span>
              </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <span class="text-topic">{{$t('warningManager.warning')}}</span>
              </div>
              </div>
          </div>
      </div>
      </div>

      <div class="row">
        <div class="vx-row" v-for="(item,index) in rowDatas" :key="index">
          <div class="vx-col w-full mt-2">
              <div class="rows-1" v-if="index%2==0">
                <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-2" style="max-width:48%;min-width:40%">
                  <span class="" style="max-width:48%;min-width:40%">{{item.contentWarning}}</span>
              </div>

              <div class="vx-col md:w-4/6 w-full mt-2" style="max-width:30%">
                  <span class="" style="margin-left:5px;text-align:center">{{item.textWarningTime}}</span>
              </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <feather-icon  class="icon" icon="EditIcon" @click="editWarning(item.id)"/>
                  <feather-icon  class="icon" icon="TrashIcon" @click="confirm(item.id)"></feather-icon>
              </div>
              </div>
              </div>

              <div class="rows-2" v-else>
                <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-2" style="max-width:48%;min-width:40%">
                  <span class="" style="max-width:48%;min-width:40%">{{item.contentWarning}}</span>
              </div>

              <div class="vx-col md:w-4/6 w-full mt-2" style="max-width:30%">
                  <span class="" style="margin-left:5px;text-align:center">{{item.textWarningTime}}</span>
              </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <feather-icon  class="icon" icon="EditIcon" @click="editWarning(item.id)"/>
                  <feather-icon  class="icon" icon="TrashIcon" @click="confirm(item.id)"></feather-icon>
              </div>
              </div>
              </div>
          </div>
      </div>
      </div>

      </div>



        <div class="warning">
          <div class="vx-row" >
          <div class="vx-col w-full mt-2" style=" margin-bottom:10px;">
            <div style="border-bottom:1px solid #ccc; padding-bottom:10px"><label ><h3 class="text-title">{{$t('warningManager.warningByContentShade')}}</h3></label></div>
          </div>
        </div>
        <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-2">
           <span class="text-topic">{{$t('warningManager.sendMe')}}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2">
            <span class="text-topic">{{$t('warningManager.whenCollected')}}</span>
        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
            <span class="text-topic">{{$t('title.shades')}}</span>
        </div>
        </div>

        <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full mt-2" style="border-right: 1px solid #ccc">
           <v-select
                    v-model="getValueSelect"
                    :clearable="false"
                    :options="optionsSelect"
                    data-vv-validate-on="input"
                    :disabled="true"
                  >
                  </v-select>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2">
          <div class="vx-row">
            <div class="vx-col md:w-1/6 w-full mt-2 mt">
            <vs-checkbox v-model="newsCheckbox" :disabled="true"><span>{{$t('warningManager.newsPapers')}}</span></vs-checkbox>
          </div>

          <div class="vx-col md:w-1/6 w-full mt-2 mt">
            <vs-checkbox v-model="checkboxYoutube" :disabled ="true" ><span>Facebook</span></vs-checkbox>
          </div>

          <div class="vx-col md:w-1/6 w-full mt-2 mt">
            <vs-checkbox v-model="checkboxYoutube" :disabled ="true" ><span>Youtube</span></vs-checkbox>
          </div>

          <div class="vx-col md:w-1/6 w-full mt-2 mts">
            <vs-checkbox v-model="checkboxOther" :disabled ="true"><span>{{$t('warningManager.other')}}</span></vs-checkbox>
          </div>

          </div>
        </div>
        <div class="vx-col md:w-1/6 w-full mt-2">
          <div class="vx-row" style="margin-left:0px">
            <vs-checkbox v-model="positiveCheckbox" :disabled="true"><span>{{$t('title.positive')}}</span></vs-checkbox>
            <vs-checkbox v-model="negativeCheckbox" :disabled="true"><span>{{$t('title.negative')}}</span></vs-checkbox>
          </div>
        </div>
      </div>
        </div>

    </div>
</template>

<script>

import vSelect from 'vue-select'

export default {
components:{
  vSelect
},
data(){
  return {

    components:{
    },

    positiveCheckbox:true,
    negativeCheckbox:false,

    newsCheckbox:true,
    commentCheckbox:true,
    socalCheckbox:true,
    checkboxProfile:true,
    checkboxOther:true,
    checkboxFacebook:true,
    checkboxYoutube:true,


    getValueSelect:{label:this.$t('warningManager.rightAway'),value:0},

    rowDatas:[],
    formData:[
      {
      id:null,
      collectContent:null,
      classification:null,
      contentWarning:null,
      warningTimes:null
    }
    ],

    optionsSelect:[
      {label:'Ngay lập tức',value:0},
      {label:'Sau 15 phút', value:15},
      {label:'Sau 30 phút', value:30},
      {label:'Sau 1 tiếng', value:60}
    ],

    valueSelect:null,
    valueId:null,
  }
},
computed:{

},
watch:{
  '$store.state.isUpdateUser'(val) {
        if (val) {
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      }
},
async created(){
  this.initScreen();
},
methods:{
  initScreen: function(){
     const payload  = {

  };
  this.$processor.post('/warning-setting/all',payload).then((response) =>{
    this.rowDatas = response.data.warningSettings;
    this.rowDatas.forEach(el =>{
      switch (el.warningTimes) {
        case 0:
          return el.textWarningTime = 'Ngay lập tức';
          break;
        case 15:
          return el.textWarningTime = "Sau 15 phút";
          break;
        case 30:
          return el.textWarningTime = "Sau 30 phút";
          break;
        case 60:
          return el.textWarningTime = "Sau 1 tiếng";
          break;
      }
    })
  }).catch(()=>{});

  },
  addWarning: function(){
    this.$router.push('/user/warning/add').catch(() =>{})
  },
  checkBoxSendMe : function (){
    this.valueSelect.label =  this.$t('warningManager.other')
  },

  deleteWarning: function(){
    if(!this.valueId) return;
    const payload ={
      id:this.valueId
    }
    this.$processor.post(`/warning-setting/delete`,payload).then((response) =>{

      this.$vs.notify({
        text: this.$t('warningManager.text5'),
        icon:'feather',
        iconPack:'icon-alert-cirlce',
        color:'primary'
      })
      return this.initScreen();
    }).catch(()=>{
      this.$vs.loading.close();
      return this.$vs.notify({
        text: this.$t('warningManager.text6'),
        icon:'feather',
        iconPack:'icon-alert-cirlce',
        color:'danger'
      })
    })
  },
    editWarning:function(value){
    this.$router.push(`/user/warning/add?id=${value}`).catch(() =>{})
  },
  confirm: function(value){
    this.valueId = value;
    this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('warningManager.titleDelete'),
          text: this.$t('warningManager.text7'),
          accept: this.deleteWarning,
          acceptText: this.$t('warningManager.acceptText'),
          cancelText: this.$t('warningManager.cancelText')
        })
  }
},
watch:{

}
}
</script>
<style scoped>
.mt{
  min-width: 150px !important;
}
.mts{
  min-width: 250px !important;
}
.warning{
    border-radius: 10px;
    padding: 5px 10px 10px 10px;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
}
.text-topic{
  font-size: 15px;
  font-weight: bold;
  vertical-align: middle;
}
.rows{
  border: 1px solid rgb(245, 245, 246);
  padding : 0px 5px 5px 10px;
  background-color: rgb(245, 245, 246);
  border-radius: 5px;
  margin-top: 20px;
}
.rows-1{
  border: 1px solid #fff;
  padding : 0px 5px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
}
.rows-2{
  border: 1px solid rgb(221 219 219 / 24%);
  padding : 0px 5px 0px 10px;
  background-color: #dae1e729;
  border-radius: 5px;
}
.text-title{
  color: #000000a3;
}
.icon{
  margin-right:20px;
  width:18px
}
.minus-top{
  margin-top: -24px;
}
</style>
